import { Inject, Injectable } from '@angular/core';
import { IComponentDetails } from '../interfaces/component-details.interface';
import { BehaviorSubject } from 'rxjs';
import { IConfig } from '../interfaces/config.interface';

@Injectable({
  providedIn: 'root'
})
export class NextComponentService {
  private nextComponentSource = new BehaviorSubject<IComponentDetails | null>(null);
  nextComponentToBeLoaded$ = this.nextComponentSource.asObservable();
  isBuyNow = false;

  constructor(@Inject('config') public SitecoreConfig: IConfig) {
    if(this.SitecoreConfig.Sitecore){
    this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow ? this.SitecoreConfig.Sitecore.isBuyNow : false;
  }
  }

  loadComponent(nextComponent: IComponentDetails) {
    this.nextComponentSource.next(nextComponent);
    if (this.isBuyNow && (window as any).ctaBuyNowReload != null) {
      try {
        /* istanbul ignore next */
        (window as any).ctaBuyNowReload.reloadView();
      } catch (e) {
        console.log(e);
      }
    }
  }

}
